import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../../../images/iconDataList.svg";

export const DataSvg = styled(svg)`
    padding: 0;
    overflow: visible;
`;